import { DatePipe } from '@angular/common';
import { NativeDateAdapter } from '@angular/material/core';

export const getCurrentTime = (): number => {
  const now = new Date();
  const hours = now.getHours().toString().padStart(2, '0');
  const minutes = now.getMinutes().toString().padStart(2, '0');
  const seconds = now.getSeconds().toString().padStart(2, '0');
  const milliseconds = now.getMilliseconds().toString().padStart(2, '0').substring(0, 2);
  return +`${hours}${minutes}${seconds}${milliseconds}`;
};

export const dateToString = (dateString: Date | null): string => {
  if (!dateString) {
    return '';
  }
  const date = new Date(dateString);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  return `${month}-${day}-${year}`;
};

export const formatDate = (timeStamp: string): string => {
  const datePipe = new DatePipe('en-US');
  if (!timeStamp) {
    return '';
  }
  return datePipe.transform(timeStamp, 'MM/dd/yyyy, hh:mm:ss a') || '';
};



export class CustomDateAdapter extends NativeDateAdapter {

  override format(date: Date, displayFormat: any): string {
    if (!date) return '';

    const day = this._to2digit(date.getDate());
    const month = this._to2digit(date.getMonth() + 1);
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
  }

  private _to2digit(n: number): string {
    return n < 10 ? '0' + n : n.toString();
  }
}